import * as React from 'react';
import { Skin } from '../models/common/Skin';
import { CheckFlat } from '../models/common/CheckFlat';
import { CheckSummary } from '../models/common/CheckSummary';
import { SplitType } from '../models/common/SplitType';
import { CheckTotal } from '../models/payment/CheckTotal';

const localState = localStorage.getItem("check_state") !== null ? JSON.parse(localStorage.getItem("check_state")!) : null;

let reducer = (state: CheckState, newState: CheckState) => {
    if (newState === null) {
        localStorage.removeItem("check_state");
        return initialState;
    }

    return { ...state, ...newState };
};

export interface CheckState {
    checkSummary: CheckSummary | null;
    checkDetail: CheckFlat | null;
    checkTotal: CheckTotal | null;
    paymentId: string | null;
    splitType: SplitType;
    splitPercentage: number;
    splitAmount: number;
    splitEvenlyCount: number;
    checkTotalWithTip: string;
    tip: number;
    tipString: string;
}

const initialState: CheckState = {
    checkSummary: null,
    checkDetail: null,
    checkTotal: null,
    paymentId: null,
    splitType: SplitType.None,
    splitPercentage: 0,
    splitAmount: 0,
    splitEvenlyCount: 0,
    checkTotalWithTip: '',
    tip: 0,
    tipString: '',
};

export const CheckStateContext = React.createContext<{state: CheckState; setState: React.Dispatch<any>;}>({state: initialState, setState: () => null});

const CheckStateContextProvider = (props: { children?: React.ReactNode }) => {
    const [checkState, setCheckState] = React.useReducer(reducer, localState || initialState);
    
    React.useEffect(() => {
        localStorage.setItem("check_state", JSON.stringify(checkState));
    }, [checkState]);

    return (
        //@ts-ignore
        <CheckStateContext.Provider value={{ state: checkState, setState: setCheckState }}>
            {props.children}
        </CheckStateContext.Provider>
    );
}

export default CheckStateContextProvider;